var graphql_AIDescriptionStatus = /*#__PURE__*/ function(AIDescriptionStatus) {
    AIDescriptionStatus["ACCEPTED"] = "ACCEPTED";
    AIDescriptionStatus["REJECTED"] = "REJECTED";
    AIDescriptionStatus["UNKNOWN"] = "UNKNOWN";
    return AIDescriptionStatus;
}({});
var graphql_AggregationType = /*#__PURE__*/ function(AggregationType) {
    AggregationType["COUNT"] = "COUNT";
    AggregationType["COUNT_SAMPLES"] = "COUNT_SAMPLES";
    AggregationType["HISTOGRAM"] = "HISTOGRAM";
    AggregationType["LAST"] = "LAST";
    AggregationType["MAX"] = "MAX";
    AggregationType["MEAN"] = "MEAN";
    AggregationType["MEDIAN"] = "MEDIAN";
    AggregationType["MIN"] = "MIN";
    AggregationType["P10"] = "P10";
    AggregationType["P20"] = "P20";
    AggregationType["P25"] = "P25";
    AggregationType["P30"] = "P30";
    AggregationType["P40"] = "P40";
    AggregationType["P50"] = "P50";
    AggregationType["P60"] = "P60";
    AggregationType["P70"] = "P70";
    AggregationType["P75"] = "P75";
    AggregationType["P80"] = "P80";
    AggregationType["P90"] = "P90";
    AggregationType["P95"] = "P95";
    AggregationType["P99"] = "P99";
    AggregationType["P999"] = "P999";
    AggregationType["P9999"] = "P9999";
    AggregationType["STDEV"] = "STDEV";
    AggregationType["SUM"] = "SUM";
    AggregationType["SUMSQ"] = "SUMSQ";
    AggregationType["TYPE_INVALID"] = "TYPE_INVALID";
    return AggregationType;
}({});
var graphql_AlertAnalysisAggregationDimensionType = /*#__PURE__*/ function(AlertAnalysisAggregationDimensionType) {
    AlertAnalysisAggregationDimensionType["MONITOR_LABEL"] = "MONITOR_LABEL";
    AlertAnalysisAggregationDimensionType["MONITOR_METADATA"] = "MONITOR_METADATA";
    AlertAnalysisAggregationDimensionType["SIGNAL"] = "SIGNAL";
    return AlertAnalysisAggregationDimensionType;
}({});
var graphql_AlertAnalysisStringMatcherOperation = /*#__PURE__*/ function(AlertAnalysisStringMatcherOperation) {
    AlertAnalysisStringMatcherOperation["ANY_OF"] = "ANY_OF";
    AlertAnalysisStringMatcherOperation["CONTAINS"] = "CONTAINS";
    AlertAnalysisStringMatcherOperation["EQUAL"] = "EQUAL";
    AlertAnalysisStringMatcherOperation["NONE_OF"] = "NONE_OF";
    AlertAnalysisStringMatcherOperation["NOT_CONTAINS"] = "NOT_CONTAINS";
    AlertAnalysisStringMatcherOperation["NOT_EQUAL"] = "NOT_EQUAL";
    AlertAnalysisStringMatcherOperation["NOT_REGEX_EQUAL"] = "NOT_REGEX_EQUAL";
    AlertAnalysisStringMatcherOperation["REGEX_EQUAL"] = "REGEX_EQUAL";
    return AlertAnalysisStringMatcherOperation;
}({});
var graphql_AlertDatastoreSeverity = /*#__PURE__*/ function(AlertDatastoreSeverity) {
    AlertDatastoreSeverity["CRITICAL"] = "CRITICAL";
    AlertDatastoreSeverity["UNKNOWN"] = "UNKNOWN";
    AlertDatastoreSeverity["WARN"] = "WARN";
    return AlertDatastoreSeverity;
}({});
var graphql_AlertDatastoreStatus = /*#__PURE__*/ function(AlertDatastoreStatus) {
    AlertDatastoreStatus["RESOLVED"] = "RESOLVED";
    AlertDatastoreStatus["TRIGGERED"] = "TRIGGERED";
    AlertDatastoreStatus["UNKNOWN"] = "UNKNOWN";
    return AlertDatastoreStatus;
}({});
var graphql_AlertEventType = /*#__PURE__*/ function(AlertEventType) {
    AlertEventType["MONITOR_MUTED"] = "MONITOR_MUTED";
    AlertEventType["MONITOR_RESOLVED"] = "MONITOR_RESOLVED";
    AlertEventType["MONITOR_RESOLVED_NOTIFICATION_FAILED_TO_SEND"] = "MONITOR_RESOLVED_NOTIFICATION_FAILED_TO_SEND";
    AlertEventType["MONITOR_RESOLVED_NOTIFICATION_SENT"] = "MONITOR_RESOLVED_NOTIFICATION_SENT";
    AlertEventType["MONITOR_TRIGGERED"] = "MONITOR_TRIGGERED";
    AlertEventType["MONITOR_TRIGGERED_NOTIFICATION_FAILED_TO_SEND"] = "MONITOR_TRIGGERED_NOTIFICATION_FAILED_TO_SEND";
    AlertEventType["MONITOR_TRIGGERED_NOTIFICATION_SENT"] = "MONITOR_TRIGGERED_NOTIFICATION_SENT";
    AlertEventType["MONITOR_UNMUTED"] = "MONITOR_UNMUTED";
    AlertEventType["UNKNOWN"] = "UNKNOWN";
    return AlertEventType;
}({});
var graphql_AlertFiltersCombineMode = /*#__PURE__*/ function(AlertFiltersCombineMode) {
    AlertFiltersCombineMode["AND"] = "AND";
    AlertFiltersCombineMode["OR"] = "OR";
    return AlertFiltersCombineMode;
}({});
var graphql_AlertRouteMatcherType = /*#__PURE__*/ function(AlertRouteMatcherType) {
    AlertRouteMatcherType["EXACT_MATCHER_TYPE"] = "EXACT_MATCHER_TYPE";
    AlertRouteMatcherType["REGEXP_MATCHER_TYPE"] = "REGEXP_MATCHER_TYPE";
    return AlertRouteMatcherType;
}({});
var graphql_AlertState = /*#__PURE__*/ function(AlertState) {
    AlertState["CRITICAL"] = "CRITICAL";
    AlertState["DOWNTIMED"] = "DOWNTIMED";
    AlertState["FIRING"] = "FIRING";
    AlertState["INACTIVE"] = "INACTIVE";
    AlertState["NODATA"] = "NODATA";
    AlertState["PASS"] = "PASS";
    AlertState["PENDING"] = "PENDING";
    AlertState["RESOLVED"] = "RESOLVED";
    AlertState["UNKNOWN"] = "UNKNOWN";
    AlertState["WARNING"] = "WARNING";
    return AlertState;
}({});
var graphql_CollectionLinkType = /*#__PURE__*/ function(CollectionLinkType) {
    CollectionLinkType["DASHBOARD"] = "DASHBOARD";
    CollectionLinkType["MONITOR"] = "MONITOR";
    return CollectionLinkType;
}({});
var graphql_CollectionType = /*#__PURE__*/ function(CollectionType) {
    CollectionType["SERVICE"] = "SERVICE";
    CollectionType["SIMPLE"] = "SIMPLE";
    return CollectionType;
}({});
var graphql_CommentStringMatcherOperation = /*#__PURE__*/ function(CommentStringMatcherOperation) {
    CommentStringMatcherOperation["ANY_OF"] = "ANY_OF";
    CommentStringMatcherOperation["CONTAINS"] = "CONTAINS";
    return CommentStringMatcherOperation;
}({});
var graphql_ComponentDiscoveryOverrideStatus = /*#__PURE__*/ function(ComponentDiscoveryOverrideStatus) {
    ComponentDiscoveryOverrideStatus["DISABLED"] = "DISABLED";
    ComponentDiscoveryOverrideStatus["ENABLED"] = "ENABLED";
    return ComponentDiscoveryOverrideStatus;
}({});
var graphql_ComponentPresentationOverrideStatus = /*#__PURE__*/ function(ComponentPresentationOverrideStatus) {
    ComponentPresentationOverrideStatus["DISABLED"] = "DISABLED";
    ComponentPresentationOverrideStatus["ENABLED"] = "ENABLED";
    return ComponentPresentationOverrideStatus;
}({});
var graphql_ComponentPresentationType = /*#__PURE__*/ function(ComponentPresentationType) {
    ComponentPresentationType["EVENTS"] = "EVENTS";
    ComponentPresentationType["PANELS"] = "PANELS";
    ComponentPresentationType["UNKNOWN"] = "UNKNOWN";
    return ComponentPresentationType;
}({});
var graphql_ComponentType = /*#__PURE__*/ function(ComponentType) {
    ComponentType["COMPUTE"] = "COMPUTE";
    ComponentType["RPC"] = "RPC";
    ComponentType["UNKNOWN"] = "UNKNOWN";
    return ComponentType;
}({});
var graphql_ConditionLevel = /*#__PURE__*/ function(ConditionLevel) {
    ConditionLevel["CRITICAL"] = "CRITICAL";
    ConditionLevel["UNKNOWN"] = "UNKNOWN";
    ConditionLevel["WARN"] = "WARN";
    return ConditionLevel;
}({});
var graphql_ConfigEntityType = /*#__PURE__*/ function(ConfigEntityType) {
    ConfigEntityType["MONITOR"] = "MONITOR";
    ConfigEntityType["SLO"] = "SLO";
    return ConfigEntityType;
}({});
var graphql_ConsumptionBudgetStatus = /*#__PURE__*/ function(ConsumptionBudgetStatus) {
    ConsumptionBudgetStatus["ALERT_CRITICAL"] = "ALERT_CRITICAL";
    ConsumptionBudgetStatus["ALERT_WARN"] = "ALERT_WARN";
    ConsumptionBudgetStatus["DROPPING"] = "DROPPING";
    ConsumptionBudgetStatus["NO_BUDGET"] = "NO_BUDGET";
    ConsumptionBudgetStatus["OK"] = "OK";
    ConsumptionBudgetStatus["UNKNOWN"] = "UNKNOWN";
    return ConsumptionBudgetStatus;
}({});
var graphql_ConsumptionBudgetThresholdAction = /*#__PURE__*/ function(ConsumptionBudgetThresholdAction) {
    ConsumptionBudgetThresholdAction["ALERT_CRITICAL"] = "ALERT_CRITICAL";
    ConsumptionBudgetThresholdAction["ALERT_WARN"] = "ALERT_WARN";
    ConsumptionBudgetThresholdAction["DROP"] = "DROP";
    return ConsumptionBudgetThresholdAction;
}({});
var graphql_ConsumptionBudgetThresholdType = /*#__PURE__*/ function(ConsumptionBudgetThresholdType) {
    ConsumptionBudgetThresholdType["DAILY_VOLUME"] = "DAILY_VOLUME";
    ConsumptionBudgetThresholdType["HOURLY_VOLUME"] = "HOURLY_VOLUME";
    ConsumptionBudgetThresholdType["INSTANT_RATE"] = "INSTANT_RATE";
    ConsumptionBudgetThresholdType["MONTHLY_VOLUME"] = "MONTHLY_VOLUME";
    ConsumptionBudgetThresholdType["ROLLING_1_DAY_VOLUME"] = "ROLLING_1_DAY_VOLUME";
    ConsumptionBudgetThresholdType["ROLLING_1_HOUR_VOLUME"] = "ROLLING_1_HOUR_VOLUME";
    ConsumptionBudgetThresholdType["ROLLING_3_HOUR_VOLUME"] = "ROLLING_3_HOUR_VOLUME";
    ConsumptionBudgetThresholdType["ROLLING_7_DAY_VOLUME"] = "ROLLING_7_DAY_VOLUME";
    ConsumptionBudgetThresholdType["WEEKLY_VOLUME"] = "WEEKLY_VOLUME";
    return ConsumptionBudgetThresholdType;
}({});
var graphql_ConsumptionPartitionFilterOperator = /*#__PURE__*/ function(ConsumptionPartitionFilterOperator) {
    ConsumptionPartitionFilterOperator["IN"] = "IN";
    ConsumptionPartitionFilterOperator["NOT_IN"] = "NOT_IN";
    return ConsumptionPartitionFilterOperator;
}({});
var graphql_ConsumptionResource = /*#__PURE__*/ function(ConsumptionResource) {
    ConsumptionResource["LOG_PERSISTED_BYTES"] = "LOG_PERSISTED_BYTES";
    ConsumptionResource["LOG_PROCESSED_BYTES"] = "LOG_PROCESSED_BYTES";
    ConsumptionResource["METRIC_PERSISTED_SERIES"] = "METRIC_PERSISTED_SERIES";
    return ConsumptionResource;
}({});
var graphql_ConsumptionTimeSeriesGroupBy = /*#__PURE__*/ function(ConsumptionTimeSeriesGroupBy) {
    ConsumptionTimeSeriesGroupBy["CONSUMED_BY_PARTITION"] = "CONSUMED_BY_PARTITION";
    ConsumptionTimeSeriesGroupBy["CONSUMED_VS_DROPPED"] = "CONSUMED_VS_DROPPED";
    ConsumptionTimeSeriesGroupBy["DROPPED_BY_PARTITION"] = "DROPPED_BY_PARTITION";
    return ConsumptionTimeSeriesGroupBy;
}({});
var graphql_ConsumptionTimeSeriesView = /*#__PURE__*/ function(ConsumptionTimeSeriesView) {
    ConsumptionTimeSeriesView["CUMULATIVE"] = "CUMULATIVE";
    ConsumptionTimeSeriesView["DAILY"] = "DAILY";
    ConsumptionTimeSeriesView["MONTHLY_CUMULATIVE"] = "MONTHLY_CUMULATIVE";
    ConsumptionTimeSeriesView["PER_SECOND"] = "PER_SECOND";
    ConsumptionTimeSeriesView["ROLLING_1_DAY"] = "ROLLING_1_DAY";
    ConsumptionTimeSeriesView["ROLLING_1_HOUR"] = "ROLLING_1_HOUR";
    ConsumptionTimeSeriesView["ROLLING_3_HOUR"] = "ROLLING_3_HOUR";
    ConsumptionTimeSeriesView["ROLLING_7_DAY"] = "ROLLING_7_DAY";
    ConsumptionTimeSeriesView["WEEKLY"] = "WEEKLY";
    return ConsumptionTimeSeriesView;
}({});
var graphql_ConsumptionTrendType = /*#__PURE__*/ function(ConsumptionTrendType) {
    ConsumptionTrendType["MONTH_OVER_MONTH"] = "MONTH_OVER_MONTH";
    ConsumptionTrendType["WEEK_OVER_WEEK"] = "WEEK_OVER_WEEK";
    return ConsumptionTrendType;
}({});
var graphql_DashboardColumn = /*#__PURE__*/ function(DashboardColumn) {
    DashboardColumn["FAVORITES"] = "FAVORITES";
    return DashboardColumn;
}({});
var graphql_DashboardOrder = /*#__PURE__*/ function(DashboardOrder) {
    DashboardOrder["ASC"] = "ASC";
    DashboardOrder["DESC"] = "DESC";
    return DashboardOrder;
}({});
var graphql_DatasetType = /*#__PURE__*/ function(DatasetType) {
    DatasetType["DATASET_TYPE_INVALID"] = "DATASET_TYPE_INVALID";
    DatasetType["LOGS"] = "LOGS";
    DatasetType["TRACES"] = "TRACES";
    return DatasetType;
}({});
var graphql_DatasourceType = /*#__PURE__*/ function(DatasourceType) {
    DatasourceType["GRAPHITE"] = "GRAPHITE";
    DatasourceType["LOGGING"] = "LOGGING";
    DatasourceType["PROMETHEUS"] = "PROMETHEUS";
    return DatasourceType;
}({});
var graphql_DerivedLabelPolicy = /*#__PURE__*/ function(DerivedLabelPolicy) {
    DerivedLabelPolicy["KEEP"] = "KEEP";
    DerivedLabelPolicy["LABEL_POLICY_INVALID"] = "LABEL_POLICY_INVALID";
    DerivedLabelPolicy["OVERRIDE"] = "OVERRIDE";
    return DerivedLabelPolicy;
}({});
var graphql_DiscoveryPipelineStatusMessageCode = /*#__PURE__*/ function(DiscoveryPipelineStatusMessageCode) {
    DiscoveryPipelineStatusMessageCode["CANDIDATE_EXCEEDS_DIMENSION_COUNT"] = "CANDIDATE_EXCEEDS_DIMENSION_COUNT";
    DiscoveryPipelineStatusMessageCode["CONFLICTING_MAPPING_VALUES"] = "CONFLICTING_MAPPING_VALUES";
    DiscoveryPipelineStatusMessageCode["EMPTY_SERVICE_OWNS_ENTITIES"] = "EMPTY_SERVICE_OWNS_ENTITIES";
    DiscoveryPipelineStatusMessageCode["MULTIPLE_SERVICE_NAMES"] = "MULTIPLE_SERVICE_NAMES";
    DiscoveryPipelineStatusMessageCode["SOURCE_LABEL_MISSING"] = "SOURCE_LABEL_MISSING";
    DiscoveryPipelineStatusMessageCode["TOO_MANY_RESULTS"] = "TOO_MANY_RESULTS";
    DiscoveryPipelineStatusMessageCode["UNIQUE_SOURCE_LABEL_NOT_FOUND"] = "UNIQUE_SOURCE_LABEL_NOT_FOUND";
    DiscoveryPipelineStatusMessageCode["UNKNOWN"] = "UNKNOWN";
    return DiscoveryPipelineStatusMessageCode;
}({});
var graphql_DiscoveryPipelineStatusMessageSeverity = /*#__PURE__*/ function(DiscoveryPipelineStatusMessageSeverity) {
    DiscoveryPipelineStatusMessageSeverity["ERROR"] = "ERROR";
    DiscoveryPipelineStatusMessageSeverity["INFO"] = "INFO";
    DiscoveryPipelineStatusMessageSeverity["UNKNOWN"] = "UNKNOWN";
    DiscoveryPipelineStatusMessageSeverity["WARNING"] = "WARNING";
    return DiscoveryPipelineStatusMessageSeverity;
}({});
var graphql_DiscoveryStatus = /*#__PURE__*/ function(DiscoveryStatus) {
    DiscoveryStatus["Added"] = "Added";
    DiscoveryStatus["Deleted"] = "Deleted";
    DiscoveryStatus["Modified"] = "Modified";
    DiscoveryStatus["Unchanged"] = "Unchanged";
    DiscoveryStatus["Unknown"] = "Unknown";
    return DiscoveryStatus;
}({});
var graphql_DocArtifactSortField = /*#__PURE__*/ function(DocArtifactSortField) {
    DocArtifactSortField["CREATED_AT"] = "CREATED_AT";
    DocArtifactSortField["KEY"] = "KEY";
    DocArtifactSortField["LABEL_NAME"] = "LABEL_NAME";
    DocArtifactSortField["UPDATED_AT"] = "UPDATED_AT";
    return DocArtifactSortField;
}({});
var graphql_DropRuleMode = /*#__PURE__*/ function(DropRuleMode) {
    DropRuleMode["DISABLED"] = "DISABLED";
    DropRuleMode["ENABLED"] = "ENABLED";
    DropRuleMode["PREVIEW"] = "PREVIEW";
    return DropRuleMode;
}({});
var graphql_EditSource = /*#__PURE__*/ function(EditSource) {
    EditSource["EDITABLE"] = "EDITABLE";
    EditSource["UNEDITABLE_K8S_OWNED"] = "UNEDITABLE_K8S_OWNED";
    EditSource["UNEDITABLE_SLO_GENERATED"] = "UNEDITABLE_SLO_GENERATED";
    EditSource["UNEDITABLE_TF_OWNED"] = "UNEDITABLE_TF_OWNED";
    return EditSource;
}({});
var graphql_EmitMetricsGaugeAggregationType = /*#__PURE__*/ function(EmitMetricsGaugeAggregationType) {
    EmitMetricsGaugeAggregationType["LAST"] = "LAST";
    EmitMetricsGaugeAggregationType["MAX"] = "MAX";
    EmitMetricsGaugeAggregationType["MIN"] = "MIN";
    return EmitMetricsGaugeAggregationType;
}({});
var graphql_EmitMetricsMode = /*#__PURE__*/ function(EmitMetricsMode) {
    EmitMetricsMode["COUNTER"] = "COUNTER";
    EmitMetricsMode["GAUGE"] = "GAUGE";
    EmitMetricsMode["HISTOGRAM"] = "HISTOGRAM";
    return EmitMetricsMode;
}({});
var graphql_EntityNamespace = /*#__PURE__*/ function(EntityNamespace) {
    EntityNamespace["CUSTOMER"] = "CUSTOMER";
    EntityNamespace["INTERNAL"] = "INTERNAL";
    EntityNamespace["MANAGED"] = "MANAGED";
    return EntityNamespace;
}({});
var graphql_EntityVersionOrder = /*#__PURE__*/ function(EntityVersionOrder) {
    EntityVersionOrder["ASC"] = "ASC";
    EntityVersionOrder["DESC"] = "DESC";
    return EntityVersionOrder;
}({});
var graphql_EntityVersionSource = /*#__PURE__*/ function(EntityVersionSource) {
    EntityVersionSource["API"] = "API";
    EntityVersionSource["CHRONOCTL"] = "CHRONOCTL";
    EntityVersionSource["TERRAFORM"] = "TERRAFORM";
    EntityVersionSource["UI"] = "UI";
    EntityVersionSource["UNKNOWN"] = "UNKNOWN";
    return EntityVersionSource;
}({});
var graphql_EntityVersionType = /*#__PURE__*/ function(EntityVersionType) {
    EntityVersionType["DASHBOARD"] = "DASHBOARD";
    EntityVersionType["LOG_CONTROL_CONFIG"] = "LOG_CONTROL_CONFIG";
    EntityVersionType["LOG_INGEST_CONFIG"] = "LOG_INGEST_CONFIG";
    EntityVersionType["MONITOR"] = "MONITOR";
    EntityVersionType["SLO"] = "SLO";
    return EntityVersionType;
}({});
var graphql_ExportFormat = /*#__PURE__*/ function(ExportFormat) {
    ExportFormat["CHRONOCTL"] = "CHRONOCTL";
    ExportFormat["TERRAFORM"] = "TERRAFORM";
    ExportFormat["UNKNOWN"] = "UNKNOWN";
    return ExportFormat;
}({});
var graphql_FavoriteEntityType = /*#__PURE__*/ function(FavoriteEntityType) {
    FavoriteEntityType["DASHBOARD"] = "DASHBOARD";
    FavoriteEntityType["GRAFANA_DASHBOARD"] = "GRAFANA_DASHBOARD";
    FavoriteEntityType["MONITOR"] = "MONITOR";
    return FavoriteEntityType;
}({});
var graphql_FeatureFlagType = /*#__PURE__*/ function(FeatureFlagType) {
    FeatureFlagType["BOOL"] = "BOOL";
    FeatureFlagType["INT"] = "INT";
    FeatureFlagType["STRING"] = "STRING";
    return FeatureFlagType;
}({});
var graphql_LabelMatcherOp = /*#__PURE__*/ function(LabelMatcherOp) {
    LabelMatcherOp["EQUALS"] = "EQUALS";
    LabelMatcherOp["NOT_EQUALS"] = "NOT_EQUALS";
    return LabelMatcherOp;
}({});
var graphql_LabelMatcherType = /*#__PURE__*/ function(LabelMatcherType) {
    LabelMatcherType["EXACT_MATCHER_TYPE"] = "EXACT_MATCHER_TYPE";
    LabelMatcherType["NOT_EXACT_MATCHER_TYPE"] = "NOT_EXACT_MATCHER_TYPE";
    LabelMatcherType["NOT_REGEXP_MATCHER_TYPE"] = "NOT_REGEXP_MATCHER_TYPE";
    LabelMatcherType["REGEXP_MATCHER_TYPE"] = "REGEXP_MATCHER_TYPE";
    return LabelMatcherType;
}({});
var graphql_LogControlRuleMode = /*#__PURE__*/ function(LogControlRuleMode) {
    LogControlRuleMode["DISABLED"] = "DISABLED";
    LogControlRuleMode["ENABLED"] = "ENABLED";
    return LogControlRuleMode;
}({});
var graphql_LogControlRuleType = /*#__PURE__*/ function(LogControlRuleType) {
    LogControlRuleType["DROP"] = "DROP";
    LogControlRuleType["DROP_FIELD"] = "DROP_FIELD";
    LogControlRuleType["EMIT_METRICS"] = "EMIT_METRICS";
    LogControlRuleType["REPLACE_FIELD"] = "REPLACE_FIELD";
    LogControlRuleType["SAMPLE"] = "SAMPLE";
    return LogControlRuleType;
}({});
var graphql_LogLookupTableErrorDetails = /*#__PURE__*/ function(LogLookupTableErrorDetails) {
    LogLookupTableErrorDetails["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    LogLookupTableErrorDetails["INVALID_FILE"] = "INVALID_FILE";
    return LogLookupTableErrorDetails;
}({});
var graphql_LogLookupTableStatus = /*#__PURE__*/ function(LogLookupTableStatus) {
    LogLookupTableStatus["ERROR"] = "ERROR";
    LogLookupTableStatus["PENDING"] = "PENDING";
    LogLookupTableStatus["PENDING_DELETION"] = "PENDING_DELETION";
    LogLookupTableStatus["READY"] = "READY";
    return LogLookupTableStatus;
}({});
var graphql_LogParserType = /*#__PURE__*/ function(LogParserType) {
    LogParserType["JSON"] = "JSON";
    LogParserType["KEY_VALUE"] = "KEY_VALUE";
    LogParserType["REGEX"] = "REGEX";
    return LogParserType;
}({});
var graphql_LoggingContractState = /*#__PURE__*/ function(LoggingContractState) {
    LoggingContractState["ACTIVE"] = "ACTIVE";
    LoggingContractState["TERMINATED"] = "TERMINATED";
    return LoggingContractState;
}({});
var graphql_ManagedBySource = /*#__PURE__*/ function(ManagedBySource) {
    ManagedBySource["CHRONOCTL"] = "CHRONOCTL";
    ManagedBySource["CHRONOSPHERE"] = "CHRONOSPHERE";
    ManagedBySource["KUBERNETES"] = "KUBERNETES";
    ManagedBySource["SYNC_PROMETHEUS"] = "SYNC_PROMETHEUS";
    ManagedBySource["TERRAFORM"] = "TERRAFORM";
    ManagedBySource["UI"] = "UI";
    ManagedBySource["UNKNOWN"] = "UNKNOWN";
    return ManagedBySource;
}({});
var graphql_MappingRuleMode = /*#__PURE__*/ function(MappingRuleMode) {
    MappingRuleMode["ENABLED"] = "ENABLED";
    MappingRuleMode["PREVIEW"] = "PREVIEW";
    return MappingRuleMode;
}({});
var graphql_Match = /*#__PURE__*/ function(Match) {
    Match["INVALID"] = "INVALID";
    Match["RULE"] = "RULE";
    return Match;
}({});
var graphql_MetricKind = /*#__PURE__*/ function(MetricKind) {
    MetricKind["FAILURE_METRIC"] = "FAILURE_METRIC";
    MetricKind["LATENCY_HISTOGRAM_BUCKET"] = "LATENCY_HISTOGRAM_BUCKET";
    MetricKind["LATENCY_HISTOGRAM_COUNT"] = "LATENCY_HISTOGRAM_COUNT";
    MetricKind["SUCCESS_METRIC"] = "SUCCESS_METRIC";
    MetricKind["TOTAL_METRIC"] = "TOTAL_METRIC";
    MetricKind["UNKNOWN"] = "UNKNOWN";
    return MetricKind;
}({});
var graphql_MetricType = /*#__PURE__*/ function(MetricType) {
    MetricType["COUNTER"] = "COUNTER";
    MetricType["CUMULATIVE_COUNTER"] = "CUMULATIVE_COUNTER";
    MetricType["CUMULATIVE_EXPONENTIAL_HISTOGRAM"] = "CUMULATIVE_EXPONENTIAL_HISTOGRAM";
    MetricType["DELTA"] = "DELTA";
    MetricType["DELTA_COUNTER"] = "DELTA_COUNTER";
    MetricType["DELTA_EXPONENTIAL_HISTOGRAM"] = "DELTA_EXPONENTIAL_HISTOGRAM";
    MetricType["DISTRIBUTION"] = "DISTRIBUTION";
    MetricType["GAUGE"] = "GAUGE";
    MetricType["MEASUREMENT"] = "MEASUREMENT";
    MetricType["METRIC_TYPE_INVALID"] = "METRIC_TYPE_INVALID";
    return MetricType;
}({});
var graphql_MutingRuleColumn = /*#__PURE__*/ function(MutingRuleColumn) {
    MutingRuleColumn["ENDS_AT"] = "ENDS_AT";
    MutingRuleColumn["STARTS_AT"] = "STARTS_AT";
    return MutingRuleColumn;
}({});
var graphql_MutingRuleState = /*#__PURE__*/ function(MutingRuleState) {
    MutingRuleState["ACTIVE"] = "ACTIVE";
    MutingRuleState["EXPIRED"] = "EXPIRED";
    MutingRuleState["PENDING"] = "PENDING";
    return MutingRuleState;
}({});
var graphql_NumericFilterComparisonType = /*#__PURE__*/ function(NumericFilterComparisonType) {
    NumericFilterComparisonType["EQUAL"] = "EQUAL";
    NumericFilterComparisonType["GREATER_THAN"] = "GREATER_THAN";
    NumericFilterComparisonType["GREATER_THAN_OR_EQUAL"] = "GREATER_THAN_OR_EQUAL";
    NumericFilterComparisonType["LESS_THAN"] = "LESS_THAN";
    NumericFilterComparisonType["LESS_THAN_OR_EQUAL"] = "LESS_THAN_OR_EQUAL";
    NumericFilterComparisonType["NOT_EQUAL"] = "NOT_EQUAL";
    NumericFilterComparisonType["UNKNOWN"] = "UNKNOWN";
    return NumericFilterComparisonType;
}({});
var graphql_ObjectMergeRuleAction = /*#__PURE__*/ function(ObjectMergeRuleAction) {
    ObjectMergeRuleAction["DROP"] = "DROP";
    ObjectMergeRuleAction["KEEP"] = "KEEP";
    ObjectMergeRuleAction["REPLACE_KEY"] = "REPLACE_KEY";
    ObjectMergeRuleAction["SUPPRESS"] = "SUPPRESS";
    ObjectMergeRuleAction["UNKNOWN"] = "UNKNOWN";
    return ObjectMergeRuleAction;
}({});
var graphql_ObjectMergeRuleStatus = /*#__PURE__*/ function(ObjectMergeRuleStatus) {
    ObjectMergeRuleStatus["DISABLED"] = "DISABLED";
    ObjectMergeRuleStatus["ENABLED"] = "ENABLED";
    return ObjectMergeRuleStatus;
}({});
var graphql_Ordering = /*#__PURE__*/ function(Ordering) {
    Ordering["ASC"] = "ASC";
    Ordering["DESC"] = "DESC";
    return Ordering;
}({});
var graphql_OriginalMetricSource = /*#__PURE__*/ function(OriginalMetricSource) {
    OriginalMetricSource["DERIVED_METRIC"] = "DERIVED_METRIC";
    OriginalMetricSource["RECORDING_RULE"] = "RECORDING_RULE";
    OriginalMetricSource["UNKNOWN_SOURCE"] = "UNKNOWN_SOURCE";
    return OriginalMetricSource;
}({});
var graphql_ParserMode = /*#__PURE__*/ function(ParserMode) {
    ParserMode["DISABLED"] = "DISABLED";
    ParserMode["ENABLED"] = "ENABLED";
    return ParserMode;
}({});
var graphql_PermissionAction = /*#__PURE__*/ function(PermissionAction) {
    PermissionAction["READ"] = "READ";
    PermissionAction["READWRITE"] = "READWRITE";
    PermissionAction["UNKNOWN"] = "UNKNOWN";
    PermissionAction["WRITE"] = "WRITE";
    return PermissionAction;
}({});
var graphql_ReplaceFieldMode = /*#__PURE__*/ function(ReplaceFieldMode) {
    ReplaceFieldMode["HASH"] = "HASH";
    ReplaceFieldMode["MAPPED_VALUE"] = "MAPPED_VALUE";
    ReplaceFieldMode["STATIC_VALUE"] = "STATIC_VALUE";
    return ReplaceFieldMode;
}({});
var graphql_ResourcePoolLicense = /*#__PURE__*/ function(ResourcePoolLicense) {
    ResourcePoolLicense["LICENSE_INVALID"] = "LICENSE_INVALID";
    ResourcePoolLicense["MATCHED_WRITES_HISTOGRAM"] = "MATCHED_WRITES_HISTOGRAM";
    ResourcePoolLicense["MATCHED_WRITES_STANDARD"] = "MATCHED_WRITES_STANDARD";
    ResourcePoolLicense["PERSISTED_CARDINALITY_HISTOGRAM"] = "PERSISTED_CARDINALITY_HISTOGRAM";
    ResourcePoolLicense["PERSISTED_CARDINALITY_STANDARD"] = "PERSISTED_CARDINALITY_STANDARD";
    ResourcePoolLicense["PERSISTED_WRITES_HISTOGRAM"] = "PERSISTED_WRITES_HISTOGRAM";
    ResourcePoolLicense["PERSISTED_WRITES_STANDARD"] = "PERSISTED_WRITES_STANDARD";
    return ResourcePoolLicense;
}({});
var graphql_ResponderType = /*#__PURE__*/ function(ResponderType) {
    ResponderType["ID"] = "ID";
    ResponderType["NAME"] = "NAME";
    ResponderType["UNKNOWN"] = "UNKNOWN";
    ResponderType["USERNAME"] = "USERNAME";
    return ResponderType;
}({});
var graphql_ResponseType = /*#__PURE__*/ function(ResponseType) {
    ResponseType["ESCALATION"] = "ESCALATION";
    ResponseType["SCHEDULE"] = "SCHEDULE";
    ResponseType["TEAM"] = "TEAM";
    ResponseType["UNKNOWN"] = "UNKNOWN";
    ResponseType["USER"] = "USER";
    return ResponseType;
}({});
var graphql_RollupRuleMode = /*#__PURE__*/ function(RollupRuleMode) {
    RollupRuleMode["ENABLED"] = "ENABLED";
    RollupRuleMode["PREVIEW"] = "PREVIEW";
    return RollupRuleMode;
}({});
var graphql_RuleEvaluationErrorCode = /*#__PURE__*/ function(RuleEvaluationErrorCode) {
    RuleEvaluationErrorCode["CONFLICTING_MONITOR_LABELS"] = "CONFLICTING_MONITOR_LABELS";
    RuleEvaluationErrorCode["CONFLICTING_RECORDING_LABELS"] = "CONFLICTING_RECORDING_LABELS";
    RuleEvaluationErrorCode["DUPLICATE_SERIES"] = "DUPLICATE_SERIES";
    RuleEvaluationErrorCode["INTERNAL"] = "INTERNAL";
    RuleEvaluationErrorCode["INVALID"] = "INVALID";
    RuleEvaluationErrorCode["LICENSE_EXCEEDED"] = "LICENSE_EXCEEDED";
    RuleEvaluationErrorCode["RESOURCE_EXHAUSTED"] = "RESOURCE_EXHAUSTED";
    RuleEvaluationErrorCode["TEMPLATE"] = "TEMPLATE";
    RuleEvaluationErrorCode["TIMEOUT"] = "TIMEOUT";
    return RuleEvaluationErrorCode;
}({});
var graphql_RuleEvaluationRuleType = /*#__PURE__*/ function(RuleEvaluationRuleType) {
    RuleEvaluationRuleType["ALERTING"] = "ALERTING";
    RuleEvaluationRuleType["INVALID"] = "INVALID";
    RuleEvaluationRuleType["RECORDING"] = "RECORDING";
    return RuleEvaluationRuleType;
}({});
var graphql_RuleEvaluationWindow = /*#__PURE__*/ function(RuleEvaluationWindow) {
    RuleEvaluationWindow["INVALID"] = "INVALID";
    RuleEvaluationWindow["WINDOW_5M"] = "WINDOW_5M";
    RuleEvaluationWindow["WINDOW_30M"] = "WINDOW_30M";
    return RuleEvaluationWindow;
}({});
var graphql_SLOType = /*#__PURE__*/ function(SLOType) {
    SLOType["ENDPOINT_AVAILABILITY"] = "ENDPOINT_AVAILABILITY";
    SLOType["LATENCY"] = "LATENCY";
    return SLOType;
}({});
var graphql_SavedTraceSearchColumn = /*#__PURE__*/ function(SavedTraceSearchColumn) {
    SavedTraceSearchColumn["CREATED_AT"] = "CREATED_AT";
    SavedTraceSearchColumn["NAME"] = "NAME";
    return SavedTraceSearchColumn;
}({});
var graphql_ScalingDirection = /*#__PURE__*/ function(ScalingDirection) {
    ScalingDirection["DOWN"] = "DOWN";
    ScalingDirection["UP"] = "UP";
    return ScalingDirection;
}({});
var graphql_SearchType = /*#__PURE__*/ function(SearchType) {
    SearchType["DATAQUERY"] = "DATAQUERY";
    SearchType["INVALID"] = "INVALID";
    SearchType["LOGGING"] = "LOGGING";
    SearchType["TIMELINE"] = "TIMELINE";
    return SearchType;
}({});
var graphql_SpanFilterMatchType = /*#__PURE__*/ function(SpanFilterMatchType) {
    SpanFilterMatchType["EXCLUDE"] = "EXCLUDE";
    SpanFilterMatchType["INCLUDE"] = "INCLUDE";
    SpanFilterMatchType["UNKNOWN"] = "UNKNOWN";
    return SpanFilterMatchType;
}({});
var graphql_StringFilterMatchType = /*#__PURE__*/ function(StringFilterMatchType) {
    StringFilterMatchType["EXACT"] = "EXACT";
    StringFilterMatchType["EXACT_NEGATION"] = "EXACT_NEGATION";
    StringFilterMatchType["IN"] = "IN";
    StringFilterMatchType["NOT_IN"] = "NOT_IN";
    StringFilterMatchType["REGEX"] = "REGEX";
    StringFilterMatchType["REGEX_NEGATION"] = "REGEX_NEGATION";
    StringFilterMatchType["UNKNOWN"] = "UNKNOWN";
    return StringFilterMatchType;
}({});
var graphql_TargetType = /*#__PURE__*/ function(TargetType) {
    TargetType["AGGREGATION_RULE"] = "AGGREGATION_RULE";
    TargetType["ALERT"] = "ALERT";
    TargetType["CHANGE_EVENT"] = "CHANGE_EVENT";
    TargetType["DROP_RULE"] = "DROP_RULE";
    TargetType["METRIC_LABEL"] = "METRIC_LABEL";
    TargetType["METRIC_NAME"] = "METRIC_NAME";
    TargetType["MONITOR"] = "MONITOR";
    TargetType["PANEL_ANNOTATION"] = "PANEL_ANNOTATION";
    TargetType["RECORDING_RULE"] = "RECORDING_RULE";
    TargetType["TESTING"] = "TESTING";
    TargetType["UNKNOWN"] = "UNKNOWN";
    return TargetType;
}({});
var graphql_ThresholdOp = /*#__PURE__*/ function(ThresholdOp) {
    ThresholdOp["EQ"] = "EQ";
    ThresholdOp["EXISTS"] = "EXISTS";
    ThresholdOp["GEQ"] = "GEQ";
    ThresholdOp["GT"] = "GT";
    ThresholdOp["INVALID"] = "INVALID";
    ThresholdOp["LEQ"] = "LEQ";
    ThresholdOp["LT"] = "LT";
    ThresholdOp["NEQ"] = "NEQ";
    ThresholdOp["NOT_EXISTS"] = "NOT_EXISTS";
    return ThresholdOp;
}({});
var graphql_TimesliceSize = /*#__PURE__*/ function(TimesliceSize) {
    TimesliceSize["FiveMinutes"] = "FiveMinutes";
    TimesliceSize["OneMinute"] = "OneMinute";
    return TimesliceSize;
}({});
var graphql_TraceAggregationGroupByType = /*#__PURE__*/ function(TraceAggregationGroupByType) {
    TraceAggregationGroupByType["OP"] = "OP";
    TraceAggregationGroupByType["SVC"] = "SVC";
    TraceAggregationGroupByType["TAG"] = "TAG";
    TraceAggregationGroupByType["UNKNOWN"] = "UNKNOWN";
    return TraceAggregationGroupByType;
}({});
var graphql_TraceBehaviorAssignmentType = /*#__PURE__*/ function(TraceBehaviorAssignmentType) {
    TraceBehaviorAssignmentType["MAIN"] = "MAIN";
    TraceBehaviorAssignmentType["OVERRIDE"] = "OVERRIDE";
    TraceBehaviorAssignmentType["REMOVED"] = "REMOVED";
    TraceBehaviorAssignmentType["UNKNOWN"] = "UNKNOWN";
    return TraceBehaviorAssignmentType;
}({});
var graphql_TraceBehaviorSamplingType = /*#__PURE__*/ function(TraceBehaviorSamplingType) {
    TraceBehaviorSamplingType["HIGH_VALUE"] = "HIGH_VALUE";
    TraceBehaviorSamplingType["LOW_VALUE"] = "LOW_VALUE";
    TraceBehaviorSamplingType["UNKNOWN"] = "UNKNOWN";
    return TraceBehaviorSamplingType;
}({});
var graphql_TraceMetricsGroupByKeyType = /*#__PURE__*/ function(TraceMetricsGroupByKeyType) {
    TraceMetricsGroupByKeyType["OPERATION"] = "OPERATION";
    TraceMetricsGroupByKeyType["PARENT_OPERATION"] = "PARENT_OPERATION";
    TraceMetricsGroupByKeyType["PARENT_SERVICE"] = "PARENT_SERVICE";
    TraceMetricsGroupByKeyType["ROOT_OPERATION"] = "ROOT_OPERATION";
    TraceMetricsGroupByKeyType["ROOT_SERVICE"] = "ROOT_SERVICE";
    TraceMetricsGroupByKeyType["SERVICE"] = "SERVICE";
    TraceMetricsGroupByKeyType["TAG"] = "TAG";
    TraceMetricsGroupByKeyType["UNKNOWN"] = "UNKNOWN";
    return TraceMetricsGroupByKeyType;
}({});
var graphql_UITheme = /*#__PURE__*/ function(UITheme) {
    UITheme["DARK"] = "DARK";
    UITheme["LIGHT"] = "LIGHT";
    UITheme["SYSTEM"] = "SYSTEM";
    UITheme["UNKNOWN"] = "UNKNOWN";
    return UITheme;
}({});
var graphql_UserState = /*#__PURE__*/ function(UserState) {
    UserState["ACTIVE"] = "ACTIVE";
    UserState["DEACTIVATED"] = "DEACTIVATED";
    UserState["INVITED"] = "INVITED";
    UserState["PENDING"] = "PENDING";
    UserState["SYNCED"] = "SYNCED";
    UserState["UNKNOWN"] = "UNKNOWN";
    return UserState;
}({});
var graphql_UserType = /*#__PURE__*/ function(UserType) {
    UserType["ACCOUNT"] = "ACCOUNT";
    UserType["SERVICE_ACCOUNT"] = "SERVICE_ACCOUNT";
    UserType["UNKNOWN"] = "UNKNOWN";
    return UserType;
}({});
var graphql_ValidationStatus = /*#__PURE__*/ function(ValidationStatus) {
    ValidationStatus["INVALID"] = "INVALID";
    ValidationStatus["UNKNOWN"] = "UNKNOWN";
    ValidationStatus["VALID"] = "VALID";
    return ValidationStatus;
}({});
var graphql_XRayNodeType = /*#__PURE__*/ function(XRayNodeType) {
    XRayNodeType["METRIC_NAME"] = "METRIC_NAME";
    XRayNodeType["QUERY"] = "QUERY";
    return XRayNodeType;
}({});
const ServiceViewAttributes = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: {
                kind: 'Name',
                value: 'ServiceViewAttributes'
            },
            typeCondition: {
                kind: 'NamedType',
                name: {
                    kind: 'Name',
                    value: 'ServiceView'
                }
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'service'
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'name'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'derivedName'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'slug'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: "description"
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'policy'
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'name'
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'slug'
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'team'
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'name'
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'slug'
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'labelsConfig'
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'name'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    alias: {
                                        kind: 'Name',
                                        value: 'traces'
                                    },
                                    name: {
                                        kind: 'Name',
                                        value: 'tracing'
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'nameMapping'
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'valueMapping'
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'name'
                                                            }
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'values'
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'events'
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'nameMapping'
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'valueMapping'
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'name'
                                                            }
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'values'
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'components'
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'name'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'slug'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'moreDetailsJSON'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'panelJSONs'
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const GetCurrentUserDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: {
                kind: 'Name',
                value: 'GetCurrentUser'
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'me'
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'id'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'email'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'isAdmin'
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const GetFeatureFlagsV2Document = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: {
                kind: 'Name',
                value: 'GetFeatureFlagsV2'
            },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: {
                            kind: 'Name',
                            value: 'flags'
                        }
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: {
                                kind: 'NonNullType',
                                type: {
                                    kind: 'NamedType',
                                    name: {
                                        kind: 'Name',
                                        value: 'FeatureFlagRequest'
                                    }
                                }
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'featureFlagsV2'
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: {
                                    kind: 'Name',
                                    value: 'flags'
                                },
                                value: {
                                    kind: 'Variable',
                                    name: {
                                        kind: 'Name',
                                        value: 'flags'
                                    }
                                }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'key'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'value'
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: {
                                                        kind: 'Name',
                                                        value: 'BoolValue'
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            alias: {
                                                                kind: 'Name',
                                                                value: 'boolValue'
                                                            },
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'value'
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: {
                                                        kind: 'Name',
                                                        value: 'StringValue'
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            alias: {
                                                                kind: 'Name',
                                                                value: 'stringValue'
                                                            },
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'value'
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: {
                                                        kind: 'Name',
                                                        value: 'IntValue'
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            alias: {
                                                                kind: 'Name',
                                                                value: 'intValue'
                                                            },
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'value'
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const GetGatewayConfigsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: {
                kind: 'Name',
                value: 'GetGatewayConfigs'
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'gatewayConfigs'
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'returnedSeriesLimit'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'returnedDatapointsLimit'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'tracingUIEnabled'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'collectionsAccess'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'serviceUIEnabled'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'sloUIEnabled'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'enableExternalServiceConfig'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'enableMetricsDDX'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'alertEntityUIEnabled'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'aiGatewayEnabled'
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'tenant'
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'tenantConfiguration'
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'scrapeInterval'
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const ServiceOverviewDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: {
                kind: 'Name',
                value: 'ServiceOverview'
            },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: {
                            kind: 'Name',
                            value: 'serviceSlug'
                        }
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'String'
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'serviceView'
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: {
                                    kind: 'Name',
                                    value: 'slug'
                                },
                                value: {
                                    kind: 'Variable',
                                    name: {
                                        kind: 'Name',
                                        value: 'serviceSlug'
                                    }
                                }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: {
                                        kind: 'Name',
                                        value: 'ServiceViewAttributes'
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: {
                kind: 'Name',
                value: 'ServiceViewAttributes'
            },
            typeCondition: {
                kind: 'NamedType',
                name: {
                    kind: 'Name',
                    value: 'ServiceView'
                }
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'service'
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'name'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'derivedName'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'slug'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: "description"
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'policy'
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'name'
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'slug'
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'team'
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'name'
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'slug'
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'labelsConfig'
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'name'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    alias: {
                                        kind: 'Name',
                                        value: 'traces'
                                    },
                                    name: {
                                        kind: 'Name',
                                        value: 'tracing'
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'nameMapping'
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'valueMapping'
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'name'
                                                            }
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'values'
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'events'
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'nameMapping'
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'valueMapping'
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'name'
                                                            }
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'values'
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'components'
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'name'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'slug'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'moreDetailsJSON'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'panelJSONs'
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const ListMonitorsQueryDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: {
                kind: 'Name',
                value: 'ListMonitorsQuery'
            },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: {
                            kind: 'Name',
                            value: 'pageSize'
                        }
                    },
                    type: {
                        kind: 'NamedType',
                        name: {
                            kind: 'Name',
                            value: 'Int'
                        }
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: {
                            kind: 'Name',
                            value: 'after'
                        }
                    },
                    type: {
                        kind: 'NamedType',
                        name: {
                            kind: 'Name',
                            value: 'String'
                        }
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: {
                            kind: 'Name',
                            value: 'filters'
                        }
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'MonitorsV2Filters'
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'monitorsV2'
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: {
                                    kind: 'Name',
                                    value: 'after'
                                },
                                value: {
                                    kind: 'Variable',
                                    name: {
                                        kind: 'Name',
                                        value: 'after'
                                    }
                                }
                            },
                            {
                                kind: 'Argument',
                                name: {
                                    kind: 'Name',
                                    value: 'pageSize'
                                },
                                value: {
                                    kind: 'Variable',
                                    name: {
                                        kind: 'Name',
                                        value: 'pageSize'
                                    }
                                }
                            },
                            {
                                kind: 'Argument',
                                name: {
                                    kind: 'Name',
                                    value: 'filters'
                                },
                                value: {
                                    kind: 'Variable',
                                    name: {
                                        kind: 'Name',
                                        value: 'filters'
                                    }
                                }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'totalCount'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'pageInfo'
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hasNextPage'
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cursor'
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'monitors'
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'slug'
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'name'
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'isFavorite'
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'spec'
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'signalGrouping'
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'labelNames'
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'signalPerSeries'
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'policy'
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'policy'
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'name'
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'slug'
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'explicitReference'
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'collection'
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'name'
                                                            }
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'type'
                                                            }
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'slug'
                                                            }
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nullableTeam'
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'id'
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'slug'
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'name'
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'exportFormat'
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'state'
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'state'
                                                            }
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'signals'
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'state'
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'series'
                                                                        },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: {
                                                                                        kind: 'Name',
                                                                                        value: 'status'
                                                                                    },
                                                                                    selectionSet: {
                                                                                        kind: 'SelectionSet',
                                                                                        selections: [
                                                                                            {
                                                                                                kind: 'Field',
                                                                                                name: {
                                                                                                    kind: 'Name',
                                                                                                    value: 'status'
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                kind: 'Field',
                                                                                                name: {
                                                                                                    kind: 'Name',
                                                                                                    value: 'startedAt'
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'labels'
                                                                        },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: {
                                                                                        kind: 'Name',
                                                                                        value: 'name'
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: {
                                                                                        kind: 'Name',
                                                                                        value: 'value'
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const SchemaTypenames = {
    Alert: 'Alert',
    AlertAnalysisAggregationBucket: 'AlertAnalysisAggregationBucket',
    AlertAnalysisAlert: 'AlertAnalysisAlert',
    AlertAnalysisMuteActionHistoryEntry: 'AlertAnalysisMuteActionHistoryEntry',
    AlertAnalysisNotifierHistoryEntry: 'AlertAnalysisNotifierHistoryEntry',
    AlertAnalysisOwnershipContext: 'AlertAnalysisOwnershipContext',
    AlertAnalysisSeverityChangeHistoryEntry: 'AlertAnalysisSeverityChangeHistoryEntry',
    AlertAnalysisSloMetadata: 'AlertAnalysisSloMetadata',
    AlertEvent: 'AlertEvent',
    AlertEventConnection: 'AlertEventConnection',
    AlertReceiver: 'AlertReceiver',
    AlertReceiverEmailConfig: 'AlertReceiverEmailConfig',
    AlertReceiverHTTPConfig: 'AlertReceiverHTTPConfig',
    AlertReceiverHTTPConfigBasicAuth: 'AlertReceiverHTTPConfigBasicAuth',
    AlertReceiverHTTPConfigTLSConfig: 'AlertReceiverHTTPConfigTLSConfig',
    AlertReceiverNotifierBaseConfig: 'AlertReceiverNotifierBaseConfig',
    AlertReceiverOpsGenieConfig: 'AlertReceiverOpsGenieConfig',
    AlertReceiverOpsGenieConfigResponder: 'AlertReceiverOpsGenieConfigResponder',
    AlertReceiverPagerdutyConfig: 'AlertReceiverPagerdutyConfig',
    AlertReceiverPagerdutyConfigImage: 'AlertReceiverPagerdutyConfigImage',
    AlertReceiverPagerdutyConfigLink: 'AlertReceiverPagerdutyConfigLink',
    AlertReceiverSlackConfig: 'AlertReceiverSlackConfig',
    AlertReceiverSlackConfigAction: 'AlertReceiverSlackConfigAction',
    AlertReceiverSlackConfigConfirmField: 'AlertReceiverSlackConfigConfirmField',
    AlertReceiverSlackConfigField: 'AlertReceiverSlackConfigField',
    AlertReceiverVictorOpsConfig: 'AlertReceiverVictorOpsConfig',
    AlertReceiverWebhookConfig: 'AlertReceiverWebhookConfig',
    AlertReceivers: 'AlertReceivers',
    AlertRouteMatcher: 'AlertRouteMatcher',
    AlertRuleLabel: 'AlertRuleLabel',
    AlertStatus: 'AlertStatus',
    AlertsConnection: 'AlertsConnection',
    AllDashboardsConnection: 'AllDashboardsConnection',
    Allocation: 'Allocation',
    AnalyzeAlertsAggregateResponse: 'AnalyzeAlertsAggregateResponse',
    AnalyzeAlertsListResponse: 'AnalyzeAlertsListResponse',
    Annotation: 'Annotation',
    Attributes: 'Attributes',
    BetweenTimeFilter: 'BetweenTimeFilter',
    BoolFilter: 'BoolFilter',
    BoolValue: 'BoolValue',
    ChronosphereLoggingConfig: 'ChronosphereLoggingConfig',
    CloseToTimeFilter: 'CloseToTimeFilter',
    Collection: 'Collection',
    CollectionDashboardConnection: 'CollectionDashboardConnection',
    CollectionDashboardLink: 'CollectionDashboardLink',
    CollectionHomepage: 'CollectionHomepage',
    CollectionLink: 'CollectionLink',
    CollectionLinksConnection: 'CollectionLinksConnection',
    CollectionMonitorLink: 'CollectionMonitorLink',
    CollectionsConnection: 'CollectionsConnection',
    Comment: 'Comment',
    CommentSearchConnection: 'CommentSearchConnection',
    CommentSearchResult: 'CommentSearchResult',
    CommentsConnection: 'CommentsConnection',
    Component: 'Component',
    ComponentDashboardPresentationConfig: 'ComponentDashboardPresentationConfig',
    ComponentDiscovery: 'ComponentDiscovery',
    ComponentDiscoveryConfig: 'ComponentDiscoveryConfig',
    ComponentDiscoveryOverride: 'ComponentDiscoveryOverride',
    ComponentEventPresentationConfig: 'ComponentEventPresentationConfig',
    ComponentPresentationConfig: 'ComponentPresentationConfig',
    ComponentPresentationOverride: 'ComponentPresentationOverride',
    ConditionOverride: 'ConditionOverride',
    ConfigEntity: 'ConfigEntity',
    ConstructedLabel: 'ConstructedLabel',
    ConsumptionBudget: 'ConsumptionBudget',
    ConsumptionBudgetAlertActionConfig: 'ConsumptionBudgetAlertActionConfig',
    ConsumptionBudgetFilter: 'ConsumptionBudgetFilter',
    ConsumptionBudgetInstantRate: 'ConsumptionBudgetInstantRate',
    ConsumptionBudgetPriority: 'ConsumptionBudgetPriority',
    ConsumptionBudgetThreshold: 'ConsumptionBudgetThreshold',
    ConsumptionBudgetVolume: 'ConsumptionBudgetVolume',
    ConsumptionContract: 'ConsumptionContract',
    ConsumptionPartition: 'ConsumptionPartition',
    ConsumptionPartitionFilter: 'ConsumptionPartitionFilter',
    ConsumptionPartitionFilterCondition: 'ConsumptionPartitionFilterCondition',
    ContainerHealth: 'ContainerHealth',
    ContainerInfo: 'ContainerInfo',
    ContainerLifecycle: 'ContainerLifecycle',
    ContainerResources: 'ContainerResources',
    CountFilter: 'CountFilter',
    CrashEvent: 'CrashEvent',
    CrashEventEvidence: 'CrashEventEvidence',
    CreatePersonalAccessTokenResponse: 'CreatePersonalAccessTokenResponse',
    CreateServiceAccountResponse: 'CreateServiceAccountResponse',
    CustomComponentOutput: 'CustomComponentOutput',
    Dashboard: 'Dashboard',
    DashboardLabel: 'DashboardLabel',
    DashboardsConnection: 'DashboardsConnection',
    Dataset: 'Dataset',
    DatasetAllocation: 'DatasetAllocation',
    DatasetConnection: 'DatasetConnection',
    DeaggregateResult: 'DeaggregateResult',
    DeaggregatedQuery: 'DeaggregatedQuery',
    DebugLog: 'DebugLog',
    DebugLogEntry: 'DebugLogEntry',
    DefaultDataset: 'DefaultDataset',
    DefaultResourcePool: 'DefaultResourcePool',
    DefaultSampleRate: 'DefaultSampleRate',
    DeploymentEvent: 'DeploymentEvent',
    DeploymentEvidence: 'DeploymentEvidence',
    DeploymentInfo: 'DeploymentInfo',
    DerivedLabel: 'DerivedLabel',
    DerivedLabelFilter: 'DerivedLabelFilter',
    DerivedLabelPreview: 'DerivedLabelPreview',
    DerivedLabelSpanTag: 'DerivedLabelSpanTag',
    DerivedLabelSpanTagNameMapping: 'DerivedLabelSpanTagNameMapping',
    DerivedLabelValueMapping: 'DerivedLabelValueMapping',
    DescriptionData: "DescriptionData",
    DiscoveredComponent: 'DiscoveredComponent',
    DiscoveredService: 'DiscoveredService',
    DiscoveryPipelineStatusMessage: 'DiscoveryPipelineStatusMessage',
    DocArtifact: 'DocArtifact',
    DocArtifactConnection: 'DocArtifactConnection',
    Downtime: 'Downtime',
    DropRule: 'DropRule',
    DropRuleValueBasedDrop: 'DropRuleValueBasedDrop',
    DropValue: 'DropValue',
    DurationFilter: 'DurationFilter',
    EligibleServicesConnection: 'EligibleServicesConnection',
    EmitMetricsCounter: 'EmitMetricsCounter',
    EmitMetricsGauge: 'EmitMetricsGauge',
    EmitMetricsHistogram: 'EmitMetricsHistogram',
    EmitMetricsLabel: 'EmitMetricsLabel',
    EntityVersion: 'EntityVersion',
    EntityVersionsConnection: 'EntityVersionsConnection',
    ErrorCodeDef: 'ErrorCodeDef',
    EventDiscovery: 'EventDiscovery',
    EventLog: 'EventLog',
    EventLogListItem: 'EventLogListItem',
    EventLogs: 'EventLogs',
    ExportConfigQuery: 'ExportConfigQuery',
    ExportedConfig: 'ExportedConfig',
    FeatureFlag: 'FeatureFlag',
    FieldNormalization: 'FieldNormalization',
    FilterQueryValidationResult: 'FilterQueryValidationResult',
    GatewayConfigs: 'GatewayConfigs',
    GeneratedDescription: "GeneratedDescription",
    GrafanaDashboard: 'GrafanaDashboard',
    GrafanaDashboardsConnection: 'GrafanaDashboardsConnection',
    GraphiteLabelPolicy: 'GraphiteLabelPolicy',
    GraphiteLabelPolicyReplace: 'GraphiteLabelPolicyReplace',
    HighLowPriorities: 'HighLowPriorities',
    ImageChange: 'ImageChange',
    ImageChangeEvent: 'ImageChangeEvent',
    IntValue: 'IntValue',
    JaegerRemotePerOperationSamplingStrategies: 'JaegerRemotePerOperationSamplingStrategies',
    JaegerRemotePerOperationSamplingStrategy: 'JaegerRemotePerOperationSamplingStrategy',
    JaegerRemoteSamplingProbabilisticStrategy: 'JaegerRemoteSamplingProbabilisticStrategy',
    JaegerRemoteSamplingRateLimitingSamplingStrategy: 'JaegerRemoteSamplingRateLimitingSamplingStrategy',
    K8sContextDiscoveryResult: 'K8sContextDiscoveryResult',
    K8sEventInference: 'K8sEventInference',
    K8sSearchCriteria: 'K8sSearchCriteria',
    KeyValueParser: 'KeyValueParser',
    KnownMetric: 'KnownMetric',
    Label: 'Label',
    LabelConfig: 'LabelConfig',
    LabelMapping: 'LabelMapping',
    LabelMatcher: 'LabelMatcher',
    LabelNames: 'LabelNames',
    LabelPair: 'LabelPair',
    LabelPolicy: 'LabelPolicy',
    LabelValues: 'LabelValues',
    Link: 'Link',
    LinkTemplate: 'LinkTemplate',
    ListDerivedLabelsConnection: 'ListDerivedLabelsConnection',
    LogAllocationConfig: 'LogAllocationConfig',
    LogControlConfig: 'LogControlConfig',
    LogControlRule: 'LogControlRule',
    LogControlRuleDropField: 'LogControlRuleDropField',
    LogControlRuleEmitMetrics: 'LogControlRuleEmitMetrics',
    LogControlRuleReplaceField: 'LogControlRuleReplaceField',
    LogControlRuleSample: 'LogControlRuleSample',
    LogDatasetConfiguration: 'LogDatasetConfiguration',
    LogFieldParser: 'LogFieldParser',
    LogFieldPath: 'LogFieldPath',
    LogIngestConfig: 'LogIngestConfig',
    LogLookupTable: 'LogLookupTable',
    LogParser: 'LogParser',
    LogSearchFilter: 'LogSearchFilter',
    LoggingContract: 'LoggingContract',
    LoggingLimit: 'LoggingLimit',
    ManagedBy: 'ManagedBy',
    MappingLabel: 'MappingLabel',
    MappingRule: 'MappingRule',
    MappingRuleAggregationPolicy: 'MappingRuleAggregationPolicy',
    MatchingMonitorRoutesAndConditions: 'MatchingMonitorRoutesAndConditions',
    MetricDDXResult: 'MetricDDXResult',
    MetricDiscovery: 'MetricDiscovery',
    MetricDiscoveryMetadata: 'MetricDiscoveryMetadata',
    MetricDiscoveryOverride: 'MetricDiscoveryOverride',
    MetricDiscoveryTarget: 'MetricDiscoveryTarget',
    MetricLabel: 'MetricLabel',
    MetricMetadata: 'MetricMetadata',
    MetricMetadataConnection: 'MetricMetadataConnection',
    MetricSettings: 'MetricSettings',
    Monitor: 'Monitor',
    MonitorCondition: 'MonitorCondition',
    MonitorMuted: 'MonitorMuted',
    MonitorNotificationPolicy: 'MonitorNotificationPolicy',
    MonitorQuery: 'MonitorQuery',
    MonitorResolvedAlertEvent: 'MonitorResolvedAlertEvent',
    MonitorResolvedNotificationFailedToSend: 'MonitorResolvedNotificationFailedToSend',
    MonitorResolvedNotificationSent: 'MonitorResolvedNotificationSent',
    MonitorSeries: 'MonitorSeries',
    MonitorSignal: 'MonitorSignal',
    MonitorSignalConfig: 'MonitorSignalConfig',
    MonitorSpec: 'MonitorSpec',
    MonitorState: 'MonitorState',
    MonitorStats: 'MonitorStats',
    MonitorSummary: 'MonitorSummary',
    MonitorTriggeredAlertEvent: 'MonitorTriggeredAlertEvent',
    MonitorTriggeredNotificationFailedToSend: 'MonitorTriggeredNotificationFailedToSend',
    MonitorTriggeredNotificationSent: 'MonitorTriggeredNotificationSent',
    MonitorUnmuted: 'MonitorUnmuted',
    MonitorsConnection: 'MonitorsConnection',
    Mutation: 'Mutation',
    MutingRule: 'MutingRule',
    MutingRuleConnection: 'MutingRuleConnection',
    MutingRulesForMonitor: 'MutingRulesForMonitor',
    NameMapping: 'NameMapping',
    NameMappingValues: 'NameMappingValues',
    NamedStringNormalization: 'NamedStringNormalization',
    NodeInfo: 'NodeInfo',
    NotificationPolicy: 'NotificationPolicy',
    NotificationPolicyConnection: 'NotificationPolicyConnection',
    NotificationRoutes: 'NotificationRoutes',
    NotificationRoutesOverride: 'NotificationRoutesOverride',
    NotificationRule: 'NotificationRule',
    Notifier: 'Notifier',
    NotifiersBySeverity: 'NotifiersBySeverity',
    NumericFilter: 'NumericFilter',
    ObjectDiscoveryMetricRule: 'ObjectDiscoveryMetricRule',
    ObjectDiscoveryRule: 'ObjectDiscoveryRule',
    ObjectMergeRule: 'ObjectMergeRule',
    OemLoggingConfig: 'OemLoggingConfig',
    PageInfo: 'PageInfo',
    Panel: 'Panel',
    PanelQuery: 'PanelQuery',
    PersonalAccessToken: 'PersonalAccessToken',
    PlaintextParser: 'PlaintextParser',
    PodInfo: 'PodInfo',
    PresentationComponent: 'PresentationComponent',
    PresentationEligibility: 'PresentationEligibility',
    ProbeStatus: 'ProbeStatus',
    PromQL: 'PromQL',
    Query: 'Query',
    RPC: 'RPC',
    RateLimit: 'RateLimit',
    RecordingRule: 'RecordingRule',
    RecordingRuleLabel: 'RecordingRuleLabel',
    RecordingRules: 'RecordingRules',
    RegexParser: 'RegexParser',
    RelativeTimeFilter: 'RelativeTimeFilter',
    ReplaceFieldMappedValue: 'ReplaceFieldMappedValue',
    ReplaceFieldMappedValuePair: 'ReplaceFieldMappedValuePair',
    ReplaceFieldStaticValue: 'ReplaceFieldStaticValue',
    ReplacementInfo: 'ReplacementInfo',
    ReplicaCountChange: 'ReplicaCountChange',
    ResourcePool: 'ResourcePool',
    ResourcePoolAllocation: 'ResourcePoolAllocation',
    ResourcePoolAllocationFixedValue: 'ResourcePoolAllocationFixedValue',
    ResourcePoolAllocationThreshold: 'ResourcePoolAllocationThreshold',
    ResourcePoolAllocationThresholds: 'ResourcePoolAllocationThresholds',
    ResourcePoolHighLowPriorities: 'ResourcePoolHighLowPriorities',
    ResourcePools: 'ResourcePools',
    RestartEvent: 'RestartEvent',
    Result: 'Result',
    RetentionPolicy: 'RetentionPolicy',
    Role: 'Role',
    RollupRule: 'RollupRule',
    RollupRuleLabelReplace: 'RollupRuleLabelReplace',
    RuleEvaluation: 'RuleEvaluation',
    RuleEvaluations: 'RuleEvaluations',
    SLI: 'SLI',
    SLIEndpointAvailability: 'SLIEndpointAvailability',
    SLIEndpointLatency: 'SLIEndpointLatency',
    SLIMetadata: 'SLIMetadata',
    SLIQueries: 'SLIQueries',
    SLITemplateData: 'SLITemplateData',
    SLITimesliceCondition: 'SLITimesliceCondition',
    SLITimesliceQueries: 'SLITimesliceQueries',
    SLO: 'SLO',
    SLOBurnRateDefinition: 'SLOBurnRateDefinition',
    SLOCalculatedBurnRate: 'SLOCalculatedBurnRate',
    SLOConnection: 'SLOConnection',
    SLODefinition: 'SLODefinition',
    SLOErrorCode: 'SLOErrorCode',
    SLOMetadataEndpointAvailability: 'SLOMetadataEndpointAvailability',
    SLOMetadataLatency: 'SLOMetadataLatency',
    SLORelatedMetricsQueries: 'SLORelatedMetricsQueries',
    SLOReportingWindow: 'SLOReportingWindow',
    SavedTraceSearch: 'SavedTraceSearch',
    SavedTraceSearchConnection: 'SavedTraceSearchConnection',
    ScalingEvent: 'ScalingEvent',
    Schedule: 'Schedule',
    ScheduleDay: 'ScheduleDay',
    ScopeFilter: 'ScopeFilter',
    SearchConnection: 'SearchConnection',
    SearchHistoryConnection: 'SearchHistoryConnection',
    SearchHistoryQuery: 'SearchHistoryQuery',
    SeriesConditions: 'SeriesConditions',
    Service: 'Service',
    ServiceAccount: 'ServiceAccount',
    ServiceAccountLabel: 'ServiceAccountLabel',
    ServiceAttribute: 'ServiceAttribute',
    ServiceComponentViewDetails: 'ServiceComponentViewDetails',
    ServiceDiscoveryOutput: 'ServiceDiscoveryOutput',
    ServiceInfo: 'ServiceInfo',
    ServiceStatuses: 'ServiceStatuses',
    ServiceToTracingServiceAttributeMap: 'ServiceToTracingServiceAttributeMap',
    ServiceView: 'ServiceView',
    ServicesConnection: 'ServicesConnection',
    Settings: 'Settings',
    SeverityCondition: 'SeverityCondition',
    ShortenedMessage: 'ShortenedMessage',
    SignalGrouping: 'SignalGrouping',
    SignedURL: 'SignedURL',
    SignupInvite: 'SignupInvite',
    SpanFilter: 'SpanFilter',
    StaticList: 'StaticList',
    StoragePolicy: 'StoragePolicy',
    StringFilter: 'StringFilter',
    StringNormalization: 'StringNormalization',
    StringValue: 'StringValue',
    SuppressionMergeRule: 'SuppressionMergeRule',
    TagFilter: 'TagFilter',
    Target: 'Target',
    Team: 'Team',
    TeamBulkUpdate: 'TeamBulkUpdate',
    TeamHomepage: 'TeamHomepage',
    TeamsForUserBulkUpdate: 'TeamsForUserBulkUpdate',
    Template: 'Template',
    TemplateValue: 'TemplateValue',
    Tenant: 'Tenant',
    TenantConfiguration: 'TenantConfiguration',
    TenantSettings: 'TenantSettings',
    TestFieldParserResult: 'TestFieldParserResult',
    TestParserResult: 'TestParserResult',
    Thread: 'Thread',
    ThreadsConnection: 'ThreadsConnection',
    TimeRange: 'TimeRange',
    TimeWindow: 'TimeWindow',
    TimelineCategory: 'TimelineCategory',
    TimestampNormalization: 'TimestampNormalization',
    TraceActiveBehaviorsConnection: 'TraceActiveBehaviorsConnection',
    TraceAggregationFocus: 'TraceAggregationFocus',
    TraceAggregationGroupByKey: 'TraceAggregationGroupByKey',
    TraceAggregationOptions: 'TraceAggregationOptions',
    TraceAggregationShape: 'TraceAggregationShape',
    TraceBehavior: 'TraceBehavior',
    TraceBehaviorActiveAssignment: 'TraceBehaviorActiveAssignment',
    TraceBehaviorConfig: 'TraceBehaviorConfig',
    TraceBehaviorErrorSampleOptions: 'TraceBehaviorErrorSampleOptions',
    TraceBehaviorFastSampleOptions: 'TraceBehaviorFastSampleOptions',
    TraceBehaviorLargeTraceSampleOptions: 'TraceBehaviorLargeTraceSampleOptions',
    TraceBehaviorMainAssignment: 'TraceBehaviorMainAssignment',
    TraceBehaviorOverrideAssignment: 'TraceBehaviorOverrideAssignment',
    TraceBehaviorSlowSampleOptions: 'TraceBehaviorSlowSampleOptions',
    TraceBehaviorSmallTraceSampleOptions: 'TraceBehaviorSmallTraceSampleOptions',
    TraceBehaviorsConnection: 'TraceBehaviorsConnection',
    TraceDatasetConfiguration: 'TraceDatasetConfiguration',
    TraceDatasetEnhancement: 'TraceDatasetEnhancement',
    TraceDiscovery: 'TraceDiscovery',
    TraceFilter: 'TraceFilter',
    TraceJaegerRemoteSamplingStrategy: 'TraceJaegerRemoteSamplingStrategy',
    TraceJaegerRemoteSamplingStrategyConnection: 'TraceJaegerRemoteSamplingStrategyConnection',
    TraceMetricsGroupBy: 'TraceMetricsGroupBy',
    TraceMetricsGroupByKey: 'TraceMetricsGroupByKey',
    TraceMetricsRule: 'TraceMetricsRule',
    TraceMetricsRulesConnection: 'TraceMetricsRulesConnection',
    TraceSearch: 'TraceSearch',
    TraceSearchFilter: 'TraceSearchFilter',
    TraceSearchHistory: 'TraceSearchHistory',
    TraceSearchHistoryConnection: 'TraceSearchHistoryConnection',
    TraceTailSamplingRule: 'TraceTailSamplingRule',
    TraceTailSamplingRules: 'TraceTailSamplingRules',
    TraceTopTag: 'TraceTopTag',
    TraceTopTags: 'TraceTopTags',
    TracingLicenseLimits: 'TracingLicenseLimits',
    TracingServiceAttributeToServiceMap: 'TracingServiceAttributeToServiceMap',
    TracingServiceMapping: 'TracingServiceMapping',
    Transform: 'Transform',
    UsageStatsConfig: 'UsageStatsConfig',
    User: 'User',
    UserSearchHistory: 'UserSearchHistory',
    UserSettings: 'UserSettings',
    ValidationResult: 'ValidationResult',
    ValueDefinition: 'ValueDefinition',
    ValueMapping: 'ValueMapping',
    XRayNodes: 'XRayNodes',
    XRayResult: 'XRayResult',
    eventFilter: 'eventFilter',
    eventFilters: 'eventFilters'
};
const GetCurrentUserContext = {
    additionalTypenames: []
};
const GetFeatureFlagsV2Context = {
    additionalTypenames: [
        'FeatureFlag'
    ]
};
const GetGatewayConfigsContext = {
    additionalTypenames: []
};
const ServiceOverviewContext = {
    additionalTypenames: [
        'LabelConfig',
        'ValueMapping',
        'Component'
    ]
};
const ListMonitorsQueryContext = {
    additionalTypenames: [
        'Monitor',
        'MonitorSignal',
        'MonitorSeries',
        'Label'
    ]
};
export { graphql_AIDescriptionStatus as AIDescriptionStatus, graphql_AggregationType as AggregationType, graphql_AlertAnalysisAggregationDimensionType as AlertAnalysisAggregationDimensionType, graphql_AlertAnalysisStringMatcherOperation as AlertAnalysisStringMatcherOperation, graphql_AlertDatastoreSeverity as AlertDatastoreSeverity, graphql_AlertDatastoreStatus as AlertDatastoreStatus, graphql_AlertEventType as AlertEventType, graphql_AlertFiltersCombineMode as AlertFiltersCombineMode, graphql_AlertRouteMatcherType as AlertRouteMatcherType, graphql_AlertState as AlertState, graphql_CollectionLinkType as CollectionLinkType, graphql_CollectionType as CollectionType, graphql_CommentStringMatcherOperation as CommentStringMatcherOperation, graphql_ComponentDiscoveryOverrideStatus as ComponentDiscoveryOverrideStatus, graphql_ComponentPresentationOverrideStatus as ComponentPresentationOverrideStatus, graphql_ComponentPresentationType as ComponentPresentationType, graphql_ComponentType as ComponentType, graphql_ConditionLevel as ConditionLevel, graphql_ConfigEntityType as ConfigEntityType, graphql_ConsumptionBudgetStatus as ConsumptionBudgetStatus, graphql_ConsumptionBudgetThresholdAction as ConsumptionBudgetThresholdAction, graphql_ConsumptionBudgetThresholdType as ConsumptionBudgetThresholdType, graphql_ConsumptionPartitionFilterOperator as ConsumptionPartitionFilterOperator, graphql_ConsumptionResource as ConsumptionResource, graphql_ConsumptionTimeSeriesGroupBy as ConsumptionTimeSeriesGroupBy, graphql_ConsumptionTimeSeriesView as ConsumptionTimeSeriesView, graphql_ConsumptionTrendType as ConsumptionTrendType, graphql_DashboardColumn as DashboardColumn, graphql_DashboardOrder as DashboardOrder, graphql_DatasetType as DatasetType, graphql_DatasourceType as DatasourceType, graphql_DerivedLabelPolicy as DerivedLabelPolicy, graphql_DiscoveryPipelineStatusMessageCode as DiscoveryPipelineStatusMessageCode, graphql_DiscoveryPipelineStatusMessageSeverity as DiscoveryPipelineStatusMessageSeverity, graphql_DiscoveryStatus as DiscoveryStatus, graphql_DocArtifactSortField as DocArtifactSortField, graphql_DropRuleMode as DropRuleMode, graphql_EditSource as EditSource, graphql_EmitMetricsGaugeAggregationType as EmitMetricsGaugeAggregationType, graphql_EmitMetricsMode as EmitMetricsMode, graphql_EntityNamespace as EntityNamespace, graphql_EntityVersionOrder as EntityVersionOrder, graphql_EntityVersionSource as EntityVersionSource, graphql_EntityVersionType as EntityVersionType, graphql_ExportFormat as ExportFormat, graphql_FavoriteEntityType as FavoriteEntityType, graphql_FeatureFlagType as FeatureFlagType, GetCurrentUserContext, GetCurrentUserDocument, GetFeatureFlagsV2Context, GetFeatureFlagsV2Document, GetGatewayConfigsContext, GetGatewayConfigsDocument, graphql_LabelMatcherOp as LabelMatcherOp, graphql_LabelMatcherType as LabelMatcherType, ListMonitorsQueryContext, ListMonitorsQueryDocument, graphql_LogControlRuleMode as LogControlRuleMode, graphql_LogControlRuleType as LogControlRuleType, graphql_LogLookupTableErrorDetails as LogLookupTableErrorDetails, graphql_LogLookupTableStatus as LogLookupTableStatus, graphql_LogParserType as LogParserType, graphql_LoggingContractState as LoggingContractState, graphql_ManagedBySource as ManagedBySource, graphql_MappingRuleMode as MappingRuleMode, graphql_Match as Match, graphql_MetricKind as MetricKind, graphql_MetricType as MetricType, graphql_MutingRuleColumn as MutingRuleColumn, graphql_MutingRuleState as MutingRuleState, graphql_NumericFilterComparisonType as NumericFilterComparisonType, graphql_ObjectMergeRuleAction as ObjectMergeRuleAction, graphql_ObjectMergeRuleStatus as ObjectMergeRuleStatus, graphql_Ordering as Ordering, graphql_OriginalMetricSource as OriginalMetricSource, graphql_ParserMode as ParserMode, graphql_PermissionAction as PermissionAction, graphql_ReplaceFieldMode as ReplaceFieldMode, graphql_ResourcePoolLicense as ResourcePoolLicense, graphql_ResponderType as ResponderType, graphql_ResponseType as ResponseType, graphql_RollupRuleMode as RollupRuleMode, graphql_RuleEvaluationErrorCode as RuleEvaluationErrorCode, graphql_RuleEvaluationRuleType as RuleEvaluationRuleType, graphql_RuleEvaluationWindow as RuleEvaluationWindow, graphql_SLOType as SLOType, graphql_SavedTraceSearchColumn as SavedTraceSearchColumn, graphql_ScalingDirection as ScalingDirection, SchemaTypenames, graphql_SearchType as SearchType, ServiceOverviewContext, ServiceOverviewDocument, ServiceViewAttributes, graphql_SpanFilterMatchType as SpanFilterMatchType, graphql_StringFilterMatchType as StringFilterMatchType, graphql_TargetType as TargetType, graphql_ThresholdOp as ThresholdOp, graphql_TimesliceSize as TimesliceSize, graphql_TraceAggregationGroupByType as TraceAggregationGroupByType, graphql_TraceBehaviorAssignmentType as TraceBehaviorAssignmentType, graphql_TraceBehaviorSamplingType as TraceBehaviorSamplingType, graphql_TraceMetricsGroupByKeyType as TraceMetricsGroupByKeyType, graphql_UITheme as UITheme, graphql_UserState as UserState, graphql_UserType as UserType, graphql_ValidationStatus as ValidationStatus, graphql_XRayNodeType as XRayNodeType };

//# sourceMappingURL=graphql.js.map